var _style, _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSportsbook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 41",
    style: {
      enableBackground: "new 0 0 40 41"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#CE4342;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-linecap:round;stroke-linejoin:round;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "color_1_",
    className: "st0",
    cx: 28.8,
    cy: 19.8,
    r: 7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 20,
    cy: 20.5,
    r: 16.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.2,29l-5.7,4.2l-5-2.8l2.8-5.7l5.7-0.7L29.2,29z M17.2,19.1l2.1-6.4L15,9.2l-5.7,3.5l0.7,7.1L17.2,19.1z  M36,17.5l-5.4,0.8L27.1,12l2.4-4.8 M11.5,34.4v-3.3L8,25.5l-3.7-1 M21.4,24.7l-4.2-5.7 M27.1,12l-7.8,0.7 M15,9.2l0.8-4.4  M9.4,12.7H5.7 M10.1,19.8L8,25.5 M18.6,30.4l-7.1,0.7 M30.6,18.4L27.1,24 M29.2,29l4.2,0.7 M23.5,33.2v3.1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSportsbook);
export default __webpack_public_path__ + "static/media/Sportsbook.cb0fef50485dd7e46d8839bf5cba664e.svg";
export { ForwardRef as ReactComponent };